import { useDebounceFn } from '@vueuse/core';

export function createKeyboardScrollHandler(delay = 300) {
  return useDebounceFn(() => {
    const activeElement = document.activeElement;

    if (!activeElement || !['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName)) {
      return;
    }

    const elementRect = activeElement?.getBoundingClientRect();
    if (!elementRect) {
      return;
    }

    const viewportHeight = window.visualViewport?.height || window.innerHeight;

    const isHidden = elementRect.top < 0 || elementRect.bottom > viewportHeight - 150;

    if (isHidden) {
      activeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, delay);
}

export function handleFormFieldEvent(event: Event, callback: () => void) {
  const target = event.target as HTMLElement;
  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) {
    callback();
  }
}
